import { render, staticRenderFns } from "./TBFCardToggleItem.vue?vue&type=template&id=2cf96e8c&"
import script from "./TBFCardToggleItem.vue?vue&type=script&lang=js&"
export * from "./TBFCardToggleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports